import { render } from "./user-list.vue?vue&type=template&id=242a8744&scoped=true"
import script from "./user-list.vue?vue&type=script&lang=js"
export * from "./user-list.vue?vue&type=script&lang=js"

import "./user-list.vue?vue&type=style&index=0&id=242a8744&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-242a8744"]])

export default __exports__